module.exports = __webpack_public_path__ + "media/images/emblems/Snake-coat_of_arms-42e8795584f7bf038945c24e31d0013d.svg";